// Scripts
import Swiper from 'swiper'
import { Autoplay, Controller, EffectFade, Pagination } from 'swiper/modules'

// Styles
import 'swiper/css/bundle'
import '../../scss/components/gallerySlider'

// configure Swiper to use modules
Swiper.use([Autoplay, Controller, EffectFade, Pagination])

// élément contenant le double carousel
const el = document.querySelector('.gallerySlider')

// https://codepen.io/ezra_siton/pen/XWrBzMp
if (!el.classList.contains('swiper-initialized')) {
  const galleryTop = new Swiper('.gallerySliderMainPic', {
    slidesPerView: 1,
    freeMode: true,
    loop: false,
    preloadImages: false, // Disable preloading of all images
    lazy: { // Enable lazy loading
      loadOnTransitionStart: true
    },
    pagination: {
      el: el.getElementsByClassName('swiper-pagination')[0]
    },
    // Navigation arrows
    navigation: {
      nextEl: el.getElementsByClassName('swiper-button-next')[0],
      prevEl: el.getElementsByClassName('swiper-button-prev')[0]
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    on: {
      lazyImageReady (swiper, slide, img) {
        // https://github.com/nolimits4web/swiper/issues/5667
        if (img.complete) {
          swiper.update()
        } else {
          img.addEventListener('load', () => {
            swiper.update()
          })
        }
      }
    },
    rewind: true
  })

  const galleryThumbs = new Swiper('.gallerySliderThumbs', {
    slidesPerView: 'auto',
    centeredSlides: true, /* ver 9 works only when centeredSlides is true */
    spaceBetween: 16,
    loop: false, /* loop & slidesPerView auto not working well with swiper 9 */
    preloadImages: false, // Disable preloading of all images
    lazy: { // Enable lazy loading
      loadOnTransitionStart: true
    },
    slideToClickedSlide: true,
    grabCursor: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    rewind: true
  })

  galleryTop.controller.control = galleryThumbs
  galleryThumbs.controller.control = galleryTop
}
